export default __webpack_public_path__ + "f5ff86f7645a785cc92798a204add870.svg";